(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9203],{

/***/ 41478:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game",
      function () {
        return __webpack_require__(64117);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_game; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
// EXTERNAL MODULE: ./app/services/services/GameServices.tsx
var GameServices = __webpack_require__(54309);
// EXTERNAL MODULE: ./app/components/ui/tabs.tsx + 1 modules
var tabs = __webpack_require__(98241);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./app/helpers/index.ts + 2 modules
var helpers = __webpack_require__(2993);
;// CONCATENATED MODULE: ./app/containers/game/GameTabMobile.tsx





const { GameAll  } = (0,helpers/* lazyImport */.ez)(()=>__webpack_require__.e(/* import() */ 1147).then(__webpack_require__.bind(__webpack_require__, 91147)), "GameAll");
const { GameRanking  } = (0,helpers/* lazyImport */.ez)(()=>__webpack_require__.e(/* import() */ 1340).then(__webpack_require__.bind(__webpack_require__, 61340)), "GameRanking");
const GAME_TAB = {
    GAME_ALL: "game_all",
    RANKING: "ranking"
};
const GameTabMobile = (param)=>{
    let { games  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tabs */.mQ, {
        defaultValue: GAME_TAB.GAME_ALL,
        className: "w-full mt-[12px] md:mt-[24px]",
        style: {
            zIndex: "2"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* TabsList */.dr, {
                className: "grid w-full grid-cols-2 mb-[16px] rounded-none px-[8px] ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                        value: GAME_TAB.GAME_ALL,
                        children: t("common.all")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsTrigger */.SP, {
                        value: GAME_TAB.RANKING,
                        children: t("common.top_chart")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                value: GAME_TAB.GAME_ALL,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameAll, {
                    games: games
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* TabsContent */.nU, {
                value: GAME_TAB.RANKING,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameRanking, {
                    games: games
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/services/query-fn/game/index.ts + 1 modules
var game = __webpack_require__(82190);
;// CONCATENATED MODULE: ./app/containers/game/index.tsx






const { GameBanner  } = (0,helpers/* lazyImport */.ez)(()=>__webpack_require__.e(/* import() */ 5791).then(__webpack_require__.bind(__webpack_require__, 55791)), "GameBanner");
const { GameAll: game_GameAll  } = (0,helpers/* lazyImport */.ez)(()=>__webpack_require__.e(/* import() */ 1147).then(__webpack_require__.bind(__webpack_require__, 91147)), "GameAll");
const { GameRanking: game_GameRanking  } = (0,helpers/* lazyImport */.ez)(()=>__webpack_require__.e(/* import() */ 1340).then(__webpack_require__.bind(__webpack_require__, 61340)), "GameRanking");
const { EditorChoice  } = (0,helpers/* lazyImport */.ez)(()=>__webpack_require__.e(/* import() */ 1823).then(__webpack_require__.bind(__webpack_require__, 61823)), "EditorChoice");
const GameContainer = (param)=>{
    let {} = param;
    const [allGames, setAllGames] = (0,react.useState)();
    const [allCategory, setAllCategory] = (0,react.useState)();
    const { data: listEditorChoice  } = (0,game/* useQueryGetListGame */.Bu)({
        category: "",
        type: "editor_choice",
        limit: 10,
        page: 1
    });
    const { data: listGameBanner  } = (0,game/* useQueryGetListGameBanner */.LI)({
        type: "list_game"
    });
    const getDataGame = async ()=>{
        const categories = await GameServices/* GameServices.getAllCategories */.o.getAllCategories().then((resp)=>{
            return resp.data.data;
        }).catch(()=>[]);
        const games = await GameServices/* GameServices.getAllGames */.o.getAllGames({
            category: "",
            type: "",
            limit: 100,
            page: 1
        }).then((resp)=>resp.data.data).catch(()=>[]);
        setAllGames(games);
        setAllCategory(categories);
    };
    (0,react.useEffect)(()=>{
        getDataGame();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            listGameBanner && allGames && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameBanner, {
                listBanner: listGameBanner,
                listGame: allGames
            }),
            allGames && allCategory && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden md:block",
                        style: {
                            zIndex: "2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorChoice, {
                                games: listEditorChoice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(game_GameRanking, {
                                games: allGames
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(game_GameAll, {
                                games: allGames.filter((game)=>{
                                    return !(listEditorChoice === null || listEditorChoice === void 0 ? void 0 : listEditorChoice.find((item)=>{
                                        return (item === null || item === void 0 ? void 0 : item.id) === game.id;
                                    })) && !(listGameBanner === null || listGameBanner === void 0 ? void 0 : listGameBanner.find((item)=>{
                                        return (item === null || item === void 0 ? void 0 : item.game_id) === game.id;
                                    }));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative md:hidden",
                        style: {
                            zIndex: "2"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTabMobile, {
                            games: allGames
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/game/index.tsx



const Home = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameContainer, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_game = ((0,esm/* withTranslation */.Zh)("common")(Home));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2888,179], function() { return __webpack_exec__(41478); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);